'use client';

import React from 'react';
import clsx from 'clsx';
import { BaseImage } from '@/components/baseImage/BaseImage';
import { primaryImageWrapper, primaryShellBase, themeStyles } from '../const';
import type { VariantSlideProps } from '../types';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';

export const PrimarySlide = ({ item, theme, index }: VariantSlideProps) => {
  const styles = themeStyles[theme];

  return (
    <div
      className={clsx(
        primaryShellBase,
        styles.container,
        theme === 'dark' && styles.panel,
      )}
    >
      <div className="grid w-full gap-20 lg:w-[90%] lg:grid-cols-[minmax(0,1.05fr)_minmax(0,1fr)] lg:items-center lg:gap-12">
        <div className={primaryImageWrapper}>
          <BaseImage
            {...item?.image}
            className="h-full w-full"
            classNameImage="h-full w-full rounded-2xl object-cover"
            prerender={index === 0}
            sizes="(max-width: 1024px) 100vw, 50vw"
          />
        </div>

        <div className="flex flex-col gap-4 lg:gap-6">
          {item?.stepLabel && (
            <div
              className={clsx(
                'text-sm font-semibold uppercase tracking-tight',
                styles.muted,
              )}
            >
              {item.stepLabel}
            </div>
          )}
          <div className="space-y-2">
            <p
              className={clsx(
                'text-lg font-semibold leading-7 md:text-xl lg:text-2xl',
                styles.heading,
              )}
            >
              {item?.title}
            </p>
            {item?.description && (
              <SerializeDescription
                description={item?.description?.content}
                className={clsx(
                  'text-base leading-relaxed md:text-lg',
                  styles.body,
                )}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
